import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './entities-panel.css';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';
import { NavLink, Route } from 'react-router-dom';
import EntityList from './entity-list/EntityList';
import RESTService from '../../services/RESTService';
import RoutingService from '../../services/RoutingService';
import ResolverList from './resolver-list/ResolverList';
import GQLPanel from './GQLPanel/GQLPanel';
const connect = new RESTService();
const RS = new RoutingService();

class EntitiesPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this);
	}
	publishGraph() {
		connect
			.publishGraph()
			.then(res => {
				console.log(res.data);
			})
			.catch(err => {
				//TODO's use the new error object
				RS.smartError(err);
			});
	}
	render() {
		return (
			<div className="entities-panel-view animated fadeIn">
				<div className="hbox vbottom">
					<HeaderBreadcrumb currentPage="Entities" />
					<div className="w-100" />
					<div className="hbox vcenter">
						<div className="small-text">Publishing pushes the latest changes to your live graph.</div>
						<button className="btn m-r-20 hbox vcenter hceter" data-rh="Publish Graph" data-rh-at="bottom" onClick={this.publishGraph}>
							<i className="mdi mdi-publish" /> Publish
						</button>
					</div>
				</div>
				<div className="tab-ctn hbox grow-1 animated fadeIn">
					<NavLink to={`/entities/models`} className="tab vbox vcenter hcenter">
						Entities
					</NavLink>
					<NavLink to={`/entities/resolvers`} className="tab vbox vcenter hcenter">
						Resolvers
					</NavLink>
					<NavLink to={`/entities/mutator`} className="tab vbox vcenter hcenter">
						Mutators
					</NavLink>
					<NavLink to={`/entities/api`} className="tab vbox vcenter hcenter">
						API Explorer
					</NavLink>
				</div>
				<div className="tab-content">
					<Route exact path={`/entities/models`} component={EntityList} />
					<Route exact path={`/entities/resolvers`} component={ResolverList} />
					<Route exact path={`/entities/mutator`} render={() => <ResolverList isMutator={true} />} />
					<Route exact path={`/entities/api`} component={GQLPanel} />
				</div>
			</div>
		);
	}
}

export default EntitiesPanel;



// WEBPACK FOOTER //
// ./src/views/entities-panel/EntitiesPanel.js